import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@/environments/environment';
import { Area } from '@/app/models/interface/area.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class AreaService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'area/';

  create(data: Partial<Area>) {
    return this.http.post<CustomResponse<Area>>(this.url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
          capacitaciones: d.areaCapacitaciones.map((a) => a.capacitacion),
        };
      }),
    );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<CustomResponse<PaginatorModel<Area[], HasPagination>>>(this.url, {
        params,
      })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          if (d && Array.isArray(d.data)) {
            return {
              ...d,
              data: d.data.map((d) => ({
                ...d,
                capacitaciones:
                  d.areaCapacitaciones?.map((m) => m.capacitacion) || [],
              })),
            };
          }
          return d;
        }),
      );
  }

  findOne(id: string) {
    const url = this.url + id;
    return this.http.get<CustomResponse<Area>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
          capacitaciones: d.areaCapacitaciones.map((a) => a.capacitacion),
        };
      }),
    );
  }

  update(tipo: Partial<Area>) {
    const url = this.url + tipo.id;
    return this.http.put<CustomResponse<Area>>(url, tipo).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
          capacitaciones: d.areaCapacitaciones.map((a) => a.capacitacion),
        };
      }),
    );
  }

  changeState(state: boolean, id: string) {
    const url = this.url + id;
    return this.http.patch<CustomResponse<Area>>(url, { state }).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
          capacitaciones: d.areaCapacitaciones.map((a) => a.capacitacion),
        };
      }),
    );
  }
}
